import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class TouchImageSequenceItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.paths = [];
        this.loop = false;
        this.direction = '';

        this._images = [];
        this._currentIndex = -1;
    }

    clear() {
        this._images = [];
        this._currentIndex = -1;
    }

    start() {
        this._currentIndex = 0;
        this._images[this._currentIndex].show();
    }

    goToNext() {
        this._images[this._currentIndex].hide();

        if (this._currentIndex < this._images.length - 1) {
            this._currentIndex++;
        } else if (this.loop) {
            this._currentIndex = 0;
        }

        this._images[this._currentIndex].show();
    }

    goToPrevious() {
        this._images[this._currentIndex].hide();

        if (this._currentIndex > 0) {
            this._currentIndex--;
        } else if (this.loop) {
            this._currentIndex = this._images.length - 1;
        }

        this._images[this._currentIndex].show();
    }

}
